import PropTypes from 'prop-types';
import { styled, alpha } from '@mui/material/styles';
import {
  Box,
  Toolbar,
  AppBar,
  IconButton,
} from '@mui/material';

import Iconify from '../../../components/iconify';
import AccountPopover from './AccountPopover';

// ----------------------------------------------------------------------

const HEADER_MOBILE = 64;
const HEADER_DESKTOP_EXPANDED = 112;
const HEADER_DESKTOP_COLLAPSED = 80;

// ----------------------------------------------------------------------

const StyledRoot = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'sidebarCollapsed',
})(({ theme, sidebarCollapsed }) => {
  const headerHeight = sidebarCollapsed
    ? HEADER_DESKTOP_COLLAPSED
    : HEADER_DESKTOP_EXPANDED;

  return {
    position: 'relative',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    width: '100%',
    flex: '0 0 auto',
    boxSizing: 'border-box',

    // Separate white header section
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    borderBottom: `1px solid ${alpha(
      theme.palette.grey[500],
      0.16
    )}`,
    color: theme.palette.text.primary,
    zIndex: 1,

    [theme.breakpoints.up('lg')]: {
      height: headerHeight,
    },
  };
});

// ----------------------------------------------------------------------

const StyledToolbar = styled(Toolbar, {
  shouldForwardProp: (prop) => prop !== 'sidebarCollapsed',
})(({ theme, sidebarCollapsed }) => {
  const desktopHeight = sidebarCollapsed
    ? HEADER_DESKTOP_COLLAPSED
    : HEADER_DESKTOP_EXPANDED;

  return {
    minHeight: `${HEADER_MOBILE}px !important`,
    height: HEADER_MOBILE,
    padding: theme.spacing(0, 2),
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.up('md')]: {
      minHeight: `${desktopHeight}px !important`,
      height: desktopHeight,
      padding: theme.spacing(0, 3),
    },

    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 4),
    },
  };
});

// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
  openmenu: PropTypes.bool,
};

// ----------------------------------------------------------------------

export default function Header({
  onOpenNav,
  openmenu = false,
}) {
  return (
    <StyledRoot
      position="relative"
      sidebarCollapsed={openmenu}
    >
      <StyledToolbar sidebarCollapsed={openmenu}>
        {/* Mobile navigation toggle */}
        <IconButton
          onClick={onOpenNav}
          aria-label="Open navigation"
          sx={{
            mr: 2,
            color: 'text.primary',
            display: { lg: 'none' },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        {/* Push the account profile to the right */}
        <Box sx={{ flexGrow: 1 }} />

        <Box
          sx={{
            ml: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <AccountPopover />
        </Box>
      </StyledToolbar>
    </StyledRoot>
  );
}